// src/pages/About.js
import React from "react";
import "../styles/About.css";

const About = () => {
  return (
    <div className="about-page">
      <header className="about-header">
        <h1>🌍 Welcome to <span className="highlight">RixxyMC</span></h1>
        <p className="intro">
          RixxyMC is India’s #1 Minecraft network — built with passion for a thriving, inclusive gaming experience.
        </p>
      </header>

      <section className="about-details">
        <p className="details">
          Founded by creators for the community, RixxyMC delivers smooth, lag-free, crossplay-compatible gameplay for Java & Bedrock players. We specialize in <strong>Lifesteal SMP</strong>, custom survival, Bedwars, Practice PvP, and more — all hosted on powerful infrastructure with 24/7 uptime.
        </p>

        <p className="details">
          Whether you're a competitive PvP player or a chill builder, you'll find your space in our community. We’re proud to support cracked clients, host regular events, giveaways, and offer unique features like claim blocks, coin shops, and premium kits.
        </p>

        <p className="details">
          RixxyMC isn’t just a server — it’s a movement. Our active Discord hosts thousands of players, moderators, creators, and friends who make every session memorable.
        </p>

        <p className="join-us">
          💫 Come join the next generation of Minecraft — only on RixxyMC.
        </p>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <h2>👥 Meet the RixxyMC Core Team</h2>
        <div className="team-members">
          <div className="team-member">
            <a href="https://www.youtube.com/@RixStonGamer" target="_blank" rel="noopener noreferrer">
              <img src="/images/rixstongamer.png" alt="RixStonGamer" className="team-member-img" />
              <h3>RixStonGamer</h3>
              <p className="role">Owner & Founder</p>
              <p className="yt">📺 YouTube Creator</p>
            </a>
          </div>

          <div className="team-member">
            <a href="https://www.youtube.com/@vkminemaker" target="_blank" rel="noopener noreferrer">
              <img src="/images/no-profile-picture-icon.png" alt="MINEMAKER" className="team-member-img" />
              <h3>MINEMAKER</h3>
              <p className="role">Co-Owner / Dev</p>
              <p className="yt">📺 YouTube Creator</p>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
